/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as ListsListIdRouteImport } from './routes/lists/$listId'
import { Route as TripsTripIdRouteImport } from './routes/trips/$tripId'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const ListsListIdRoute = ListsListIdRouteImport.update({
  id: '/lists/$listId',
  path: '/lists/$listId',
  getParentRoute: () => rootRouteImport,
} as any)
const TripsTripIdRoute = TripsTripIdRouteImport.update({
  id: '/trips/$tripId',
  path: '/trips/$tripId',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/settings': typeof SettingsRoute
  '/lists/$listId': typeof ListsListIdRoute
  '/trips/$tripId': typeof TripsTripIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/settings': typeof SettingsRoute
  '/lists/$listId': typeof ListsListIdRoute
  '/trips/$tripId': typeof TripsTripIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/settings': typeof SettingsRoute
  '/lists/$listId': typeof ListsListIdRoute
  '/trips/$tripId': typeof TripsTripIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/' | '/settings' | '/lists/$listId' | '/trips/$tripId'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/settings' | '/lists/$listId' | '/trips/$tripId'
  id: '__root__' | '/' | '/settings' | '/lists/$listId' | '/trips/$tripId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  SettingsRoute: typeof SettingsRoute
  ListsListIdRoute: typeof ListsListIdRoute
  TripsTripIdRoute: typeof TripsTripIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/lists/$listId': {
      id: '/lists/$listId'
      path: '/lists/$listId'
      fullPath: '/lists/$listId'
      preLoaderRoute: typeof ListsListIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/trips/$tripId': {
      id: '/trips/$tripId'
      path: '/trips/$tripId'
      fullPath: '/trips/$tripId'
      preLoaderRoute: typeof TripsTripIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  SettingsRoute: SettingsRoute,
  ListsListIdRoute: ListsListIdRoute,
  TripsTripIdRoute: TripsTripIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
